// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "(max-width: 1024px) and (min-width: 601px)";
var _4 = "screen and (max-width: 600px)";
var _5 = "segments-3Ho24";
var _6 = "segments_multiCity-rMqIH";
export { _1 as "__esModule", _2 as "tablet", _3 as "tablet_only", _4 as "mobile", _5 as "segments", _6 as "segments_multiCity" }
export default { "__esModule": _1, "tablet": _2, "tablet_only": _3, "mobile": _4, "segments": _5, "segments_multiCity": _6 }
